export default "__VITE_ASSET__DUCnmTwq__"